<template>
  <div class="pop-manual">
    <div class="heaer-text">推广数据录入</div>
    <el-form
      class="filters"
      ref="form"
      :model="formSearch"
      inline
      label-width="80px"
    >
      <el-form-item label="产品">
        <product-select
          :value.sync="formSearch.afid"
          :multiple="true"
          placeholder="请选择产品"
          @change="handerAfid"
          popper-class="BI-select BI-select-product"
        >
        </product-select>
      </el-form-item>
      <el-form-item label="地区">
        <areaMultiSelect
          :value.sync="formSearch.geo"
          :optionsList="countryList"
        >
        </areaMultiSelect>
      </el-form-item>
      <el-form-item label="渠道">
        <el-select
          class="multiple-select"
          v-model="formSearch.mediaSource"
          placeholder="全部渠道"
          filterable
          collapse-tags
          multiple
        >
          <el-option
            v-for="item in mediaList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getCurrentPage(1)">查询</el-button>
        <el-button @click="formSearch = $options.data().formSearch"
          >重置</el-button
        >
      </el-form-item>
      <el-form-item class="other-actions">
        <el-button @click="downTemplate">下载模板</el-button>
        <el-button @click="uploadVisible = true">批量上传</el-button>
        <el-button @click="$refs.entryDialog.showModal()" type="primary"
          >录入数据</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      id="table"
      :data="tableData"
      :max-height="tableHeight"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      ref="table"
    >
      <el-table-column
        v-for="(item, i) in column"
        :prop="item.key"
        :label="item.name"
        :key="i"
        align="center"
        :width="item.width"
      >
        <template slot-scope="{ row }">
          {{
            item.dataMapping ? item.dataMapping[row[item.key]] : row[item.key]
          }}
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="{ row }">
          <div class="actions" style="display: flex; gap: 12px">
            <el-link
              type="primary"
              @click="$refs.entryDialog.showModal('IS_VIEW', row)"
              >查看</el-link
            >
            <el-link
              v-if="row.dataStatus == 0"
              type="primary"
              @click="$refs.entryDialog.showModal('IS_EDITING', row)"
              >编辑</el-link
            >
            <el-link type="danger" @click="deleteData({ id: row.id })"
              >删除</el-link
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <SelfPagination
      :total="total"
      :pageSize="formSearch.pageSize"
      :currentPage="formSearch.pageNum"
      @getCurrentPage="getCurrentPage"
      @handleSizeChange="changePageSize"
      ref="tabelPagination"
    ></SelfPagination>
    <EntryDialog ref="entryDialog" @refresh="loadData()"></EntryDialog>
    <UploadExcel
      :uploadVisible="uploadVisible"
      @closeUploadFile="closeUploadFile"
    ></UploadExcel>
  </div>
</template>

<script>
import EntryDialog from "./entryDialog.vue";
import { getRecordPageList, deleteRecord } from "@/api/popuManual.js";
import { getMedias } from "@/api/lt-check.js";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
import UploadExcel from "./UploadExcel.vue";
import { downLoadWrokSheet } from "@/utils/commonTools.js";

export default {
  name: "popManual",
  components: {
    areaMultiSelect,
    EntryDialog,
    UploadExcel,
  },

  data() {
    return {
      tableData: [],
      uploadVisible: false,
      loading: true,
      totalColumn: [],
      countryList: [],
      mediaList: [],
      formSearch: {
        afid: [],
        geo: [],
        mediaSource: [],
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      tableHeight: window.innerHeight - 200,
    };
  },
  computed: {
    column() {
      return [
        { key: "productName", name: "产品名称" },
        { key: "afid", name: "唯一标识" },
        { key: "geo", name: "地区" },
        { key: "mediaSource", name: "渠道" },
        { key: "createTime", name: "录入时间" },
        { key: "dateRange", name: "时间区间" },
        {
          key: "dataStatus",
          name: "状态",
          dataMapping: {
            0: "保存",
            1: "入库",
            2: "删除",
          },
        },
        {
          key: "creator",
          name: "操作者",
        },
      ];
    },
  },
  async mounted() {
    let param = {
      order: "asc",
      offset: 0,
    };
    this.$store.dispatch("getProductTableList", {
      param,
      cb: (data) => {
        if (data.length && data[0]) {
          this.$store.dispatch("getCountryList", {
            afid: data[0].afid,
            cb: (result) => {
              this.countryList = result;
            },
          });
        }
      },
    });

    const { code, mediaList } = await getMedias();
    if (code !== "0000") return;
    this.mediaList = mediaList;

    this.loadData();
  },
  methods: {
    downTemplate() {
      const data = [
        {
          num: 1,
          dateStr: "20231006",
          // productName: "节奏钢琴",
          afid: "XXXX",
          geo: "CN",
          mediaSource: "OPPP",
          usCost: "888.88",
          rmbCost: "888.88",
        },
        {
          num: 2,
          dateStr: "20231006",
          // productName: "节奏钢琴",
          afid: "XXXX",
          geo: "CN",
          mediaSource: "OPPP",
          usCost: "888.88",
          rmbCost: "888.88",
        },
      ];
      const headers = {
        num: "序号",
        dateStr: "日期",
        // productName: "产品名称",
        afid: "唯一标识",
        geo: "地区",
        mediaSource: "渠道",
        usCost: "推广数据（美金）",
        rmbCost: "推广数据（人民币）",
      };
      downLoadWrokSheet(data, "推广数据上传模板.xlsx", headers);
    },
    handerAfid(e) {
      this.formSearch.geo = [];
      this.$store.dispatch("getCountryList", {
        afid: e,
        cb: (result) => {
          this.countryList = result;
        },
      });
    },
    deleteData({ id }) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          const { code, msg } = await deleteRecord({ id });
          if (code !== "0000") return this.$message.error(msg);
          this.loading = false;
          this.loadData();
        })
        .catch(() => {});
    },
    getCurrentPage(page) {
      this.formSearch.pageNum = page;
      this.loadData();
    },
    changePageSize(size) {
      this.formSearch.pageNum = 1;
      this.formSearch.pageSize = size;
      this.loadData();
    },
    async loadData() {
      try {
        this.loading = true;
        const { code, msg, data } = await getRecordPageList(this.formSearch);
        if (code !== "0000") return this.$message.error(msg);
        this.tableData = data.list;
        this.total = data.total;
        this.formSearch.pageNum = data.pageNum;
        this.formSearch.pageSize = data.pageSize;
        // eslint-disable-next-line no-empty
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    showUploadFile() {
      this.uploadVisible = true;
    },
    closeUploadFile() {
      this.uploadVisible = false;
    },
    showLoding() {
      this.loading = true;
    },
    downloadFile() {
      this.$refs.usertable.downLoadFileToExcel();
    },
    computTotalColumn(arr) {
      this.totalColumn = arr;
    },
  },
};
</script>
<style lang="less" scoped>
.pop-manual {
  .heaer-text {
    margin-bottom: 16px;
    padding: 16px 16px 6px 16px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }

  .filters {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .other-actions {
      margin-left: auto;
    }
  }
}
</style>
